import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  reviewScreenAirOnHoldBannerHeading: {
    id: "review screen: review page steps app on hold banner heading",
    defaultMessage: "Your application is on hold",
  },
  reviewScreenAirOnHoldBannerText: {
    id: "review screen: review page steps app on hold banner text",
    defaultMessage:
      "Please complete the {count, plural, one {request} other {requests}} for additional information to progress your application.",
  },
  reviewScreenManualAirOnHoldBannerSelfServeText: {
    id: "review screen: review page steps app manual on hold banner text",
    defaultMessage: "Wayflyer has sent you an email with more information on how to progress your application.",
  },
  reviewScreenManualAirOnHoldBannerRepOwnedText: {
    id: "review screen: review page steps app manual on hold banner text for rep owned",
    defaultMessage:
      "Your Wayflyer Sales representative will be in contact with you to further progress your application.",
  },
  reviewScreenAirsSubmittedBanner: {
    id: "review screen: review page steps app airs submitted banner",
    defaultMessage: "You have submitted your outstanding requests",
  },
  reviewScreenAirBannerCTAText: {
    id: "review screen: review page steps banner cta label",
    defaultMessage: "View {count, plural, one {request} other {requests}}",
  },
  reviewScreenCheckingDataStep: {
    id: "review screen: checking data step",
    defaultMessage: "Checking data",
  },
  reviewScreenCheckingDataStepDetails: {
    id: "review screen: checking data step title",
    defaultMessage:
      "We're verifying your data to ensure that we have all the information needed to make an assessment of your business performance.",
  },
  reviewScreenPreparingOffersStep: {
    id: "review screen: preparing offers step",
    defaultMessage: "Preparing offers",
  },
  reviewScreenPreparingOffersStepDetails: {
    id: "review screen: preparing offers step details",
    defaultMessage:
      "We're tailoring offers to suit the needs of your business. Once you've accepted an offer funds can be deposited into your bank within 24 hours.",
  },
  reviewScreenPullingDataStep: {
    id: "review screen: pulling data step title",
    defaultMessage: "Pulling data",
  },
  reviewScreenPullingDataStepDetails: {
    id: "review screen: pulling data step details",
    defaultMessage: "We're collecting data from your platforms to conduct a thorough analysis of your business.",
  },
  reviewScreenFinancialAssessmentStep: {
    id: "review screen: financial assessment step",
    defaultMessage: "Financial assessment",
  },
  reviewScreenFinancialAssessmentStepDetails: {
    id: "review screen: financial assessment step details",
    defaultMessage:
      "We're reviewing the data you shared to assess your company's financial health and growth potential.",
  },
});
